export default {
  data: () => ({
    dialog: {
      show: false,
      title: "Informacja",
      text: "Dane zostały zapisane.",
      callback: null
    }
  }),
  methods: {
    onErrorResponse (error) {
      this.dialog.callback = null;
      this.dialog.text = this.prepareErrorMessage(error);
      this.dialog.show = true;
    },

    prepareErrorMessage (error) {
      if (error && error.response) {
        if (error.response.data && error.response.data.message) {
          return error.response.data.message;
        } else if (error.response.message) {
          return error.response.message;
        }
      }
      return "Nie udało się wykonać żądanie.";
    }
  }
};
